module.exports = __webpack_public_path__ + "img/TUN.d92c491c.svg";